import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import PracticeInfoForm from 'pages/Dashboard/components/PracticeInfoForm';
import PatientInfoForm from 'pages/Dashboard/components/PatientInfoForm';
import {
  PatientDemographicFormConsent,
  PatientInviteFormConsent,
  SMSConsent,
} from 'pages/Dashboard/components/AddPatientConsents';
import { PatientForm } from 'pages/Dashboard/types';
import { CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Toast, { ToastProps } from 'components/Common/Toast';
import HLButton from 'components/HLButton';

interface IProps {
  onSubmit: SubmitHandler<PatientForm>;
  patientFormDemographic: boolean;
  addPatientWithoutInvite: boolean;
  setPatientFormDemographic: (val: boolean) => void;
  isLoading: boolean;
  setIsMinor?: (isMinor: boolean) => void;
  onSuccess?: (value: React.SetStateAction<boolean>) => void;
}

export default function AddNewPatientForm({
  onSubmit,
  patientFormDemographic,
  addPatientWithoutInvite,
  setPatientFormDemographic,
  isLoading,
  setIsMinor,
  onSuccess,
}: IProps) {
  const { handleSubmit, watch, formState } = useFormContext();
  const [uploadToastProps, setUploadToastProps] = React.useState<ToastProps | null>(null);
  const mobile = watch('mobile');

  function getButtonContent() {
    if (isLoading) {
      return <CircularProgress color='primary' size={30} />;
    }
    return (
      addPatientWithoutInvite && patientFormDemographic && !mobile
        ? 'Add patient'
        : 'Send invite'
    );
  }

  return (
    <>
      {uploadToastProps && (
      <Toast
        {...uploadToastProps}
        onClose={() => setUploadToastProps(null)}
      />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <PracticeInfoForm />
          </Grid>
          <Grid item>
            <PatientInfoForm
              isDemographicForm={patientFormDemographic}
              addPatientWithoutInvite={addPatientWithoutInvite}
              setIsDemographicForm={setPatientFormDemographic}
              setIsMinor={setIsMinor}
              onSuccess={onSuccess}
              setUploadToastProps={setUploadToastProps}
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 6, mb: 2 }}>
          <HLButton
            color='success'
            variant='contained'
            type='submit'
            size='large'
            sx={{
              width: { xs: '100%', md: 'auto' },
            }}
            disabled={
            isLoading
            || formState.isSubmitting
            || (formState.isSubmitSuccessful && !formState.isDirty)
          }
            startIcon={<SendIcon />}
          >
            {getButtonContent()}
          </HLButton>
        </Box>
        {!patientFormDemographic && <SMSConsent />}
        <Box mt={2}>
          {patientFormDemographic ? <PatientDemographicFormConsent />
            : <PatientInviteFormConsent />}
        </Box>
      </form>
    </>
  );
}
